import { render, staticRenderFns } from "./BlockListFormCustom.vue?vue&type=template&id=27c9006f&"
import script from "./BlockListFormCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListFormCustom.vue?vue&type=script&lang=js&"
import style0 from "./BlockListFormCustom.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports